import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';
import { getSignupUserId } from '../signup-user';

@Component({
  selector: 'app-reg-driver-preview',
  templateUrl: './reg-driver-preview.component.html',
  styleUrls: ['./reg-driver-preview.component.scss']
})
export class RegDriverPreviewComponent implements OnInit {
  globals = Globals;
  profileDetails: any = {};
  isLoadingResults = false;
  submitted = false;
  connectStatus: any = null;

  constructor(private service: HttpService, private router: Router) {}

  ngOnInit() {
    this.profileDetails = JSON.parse(localStorage.getItem('driverProfile') || '{}');
    if (this.profileDetails.driverCreated && this.profileDetails.driverId) {
      this.submitted = true;
      this.loadConnectStatus();
    }
  }

  loadConnectStatus() {
    const merchantId = getSignupUserId();
    if (!merchantId || !this.profileDetails.driverId) {
      return;
    }
    this.service.getRequest(this.globals.urls.signUp.noauth.driverConnectStatus, {
      merchantId,
      _id: merchantId,
      driverId: this.profileDetails.driverId
    }).subscribe(
      res => {
        if (res.success === 1 && res.data) {
          this.connectStatus = res.data;
        }
      },
      () => { /* ignore */ }
    );
  }

  postDriver() {
    // Driver is created during payout-setup; preview is confirmation only.
    if (this.profileDetails.driverCreated && this.profileDetails.driverId) {
      this.submitted = true;
      return;
    }

    const merchantId = getSignupUserId();
    const params = {
      merchantId,
      _id: merchantId,
      profileImage: this.profileDetails.profileImage,
      email: this.profileDetails.email,
      phoneNumberPrefix: this.profileDetails.phoneNumberPrefix,
      phoneNumber: this.profileDetails.phoneNumber,
      firstName: this.profileDetails.firstName,
      lastName: this.profileDetails.lastName,
      displayName: this.profileDetails.displayName || this.profileDetails.firstName || '',
      vehicleId: this.profileDetails.vehicleId,
      licenseFrontImage: this.profileDetails.licenseFrontImage,
      identityCardFrontImage: this.profileDetails.identityCardFrontImage,
      licenseExpiry: this.profileDetails.licenseExpiry,
      lineAddress: this.profileDetails.lineAddress,
      city: this.profileDetails.city,
      country: this.profileDetails.country,
      postalCode: this.profileDetails.postalCode,
      state: this.profileDetails.state,
      mailingLineAddress: this.profileDetails.mailingLineAddress || '',
      mailingCity: this.profileDetails.mailingCity || '',
      mailingCountry: this.profileDetails.mailingCountry || '',
      mailingPostalCode: this.profileDetails.mailingPostalCode || '',
      mailingState: this.profileDetails.mailingState || '',
      rental: this.profileDetails.rental,
      monthlyRentalAmount: this.profileDetails.monthlyRentalAmount,
      dob: this.profileDetails.dob
    };
    this.isLoadingResults = true;
    this.service.postRequest(this.globals.urls.signUp.noauth.addDriver, params).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1) {
          this.service.showSuccess(res.message, 'Success');
          if (res.data && res.data.driverId) {
            this.profileDetails.driverId = res.data.driverId;
            this.profileDetails.driverCreated = true;
            localStorage.setItem('driverProfile', JSON.stringify(this.profileDetails));
          }
          this.submitted = true;
        } else {
          this.service.showError(res.message, 'Error');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  addAnother() {
    this.submitted = false;
    this.connectStatus = null;
    localStorage.removeItem('driverProfile');
    localStorage.removeItem('reg-driver-payout-submitted');
    this.router.navigate(['/registration/drivers/profile-details']);
  }

  goLogin() {
    localStorage.removeItem('driverProfile');
    this.router.navigate(['/login']);
  }
}
